import { Link } from 'react-router-dom'

const PROGRAM_ICONS = {
    tritonhacks: (
        <svg className="w-20 h-20 text-brand-blue" viewBox="0 0 64 64" fill="currentColor">
            <rect x="29" y="28" width="6" height="32" rx="1" />
            <path d="M32 4L27 20H37L32 4Z" />
            <rect x="29" y="18" width="6" height="12" />
            <path d="M18 12L14 24H22L18 12Z" />
            <rect x="16" y="22" width="4" height="10" />
            <path d="M18 32Q18 28 29 28" stroke="currentColor" strokeWidth="4" fill="none" />
            <path d="M46 12L42 24H50L46 12Z" />
            <rect x="44" y="22" width="4" height="10" />
            <path d="M46 32Q46 28 35 28" stroke="currentColor" strokeWidth="4" fill="none" />
        </svg>
    ),
    curriculum: (
        <svg className="w-20 h-20 text-brand-blue" viewBox="0 0 64 64" fill="none" stroke="currentColor" strokeWidth="2">
            <rect x="8" y="12" width="48" height="32" rx="2" />
            <rect x="12" y="16" width="40" height="24" rx="1" />
            <path d="M4 44H60L56 52H8L4 44Z" fill="currentColor" />
            <rect x="24" y="20" width="16" height="2" fill="currentColor" />
            <rect x="20" y="26" width="24" height="2" fill="currentColor" />
            <rect x="22" y="32" width="20" height="2" fill="currentColor" />
        </svg>
    ),
    earlystart: (
        <svg className="w-20 h-20 text-brand-blue" viewBox="0 0 64 64" fill="currentColor">
            <path d="M32 8C28 8 24 10 24 14V20C20 20 16 22 16 26V38C16 46 22 52 30 52H34C42 52 48 46 48 38V26C48 22 44 20 40 20V14C40 10 36 8 32 8Z" opacity="0.3" />
            <path d="M20 28C18 28 16 30 16 32V40C16 44 18 46 20 46" strokeWidth="2" stroke="currentColor" fill="none" />
            <path d="M44 28C46 28 48 30 48 32V40C48 44 46 46 44 46" strokeWidth="2" stroke="currentColor" fill="none" />
            <circle cx="28" cy="24" r="4" />
            <circle cx="36" cy="24" r="4" />
            <path d="M26 36H38" strokeWidth="2" stroke="currentColor" strokeLinecap="round" />
        </svg>
    ),
}

function ProgramCard({ program }) {
    return (
        <div className="bg-white p-10 rounded-2xl shadow-lg hover:-translate-y-2 hover:shadow-xl transition-all duration-300 flex flex-col items-center text-center border border-gray-100">
            {/* Logo */}
            <div className="w-32 h-32 flex items-center justify-center mb-6">
                {PROGRAM_ICONS[program.id]}
            </div>

            {/* Title */}
            <h4 className="text-2xl font-heading font-bold text-gray-800 mb-4">
                {program.title}
            </h4>

            {/* Description */}
            <p className="text-gray-600 text-base leading-relaxed mb-6 flex-grow">
                {program.description}
            </p>

            {/* Link */}
            <Link
                to={program.href}
                className="btn btn-primary-solid rounded-lg text-sm"
            >
                LEARN MORE
            </Link>
        </div>
    )
}

export default ProgramCard
